import { Divider, Popover } from "antd";
import { InternalControlSearchProps, TSearchOption } from "./search-template";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import { getDataTypeIcon } from "@src/pages/intelligence-search/constant/data-type-icons";
import Highlighter, { HighlighterProps } from "react-highlight-words";
import React from "react";
import { FilterIcon } from "@src/pages/intelligence-search/icons";
const Highlighter18 = Highlighter as typeof React.Component<HighlighterProps>;

export const SearchRenderLabelOption: React.FC<{
  searchValue: string;
  option: TSearchOption;
  control: InternalControlSearchProps;
}> = ({ searchValue, option, control }) => {
  const { meta } = option;
  const { disabledLabelOnly, disabledFilterOnly, disabledFull, isCustomMetric, unlikelyReasons } = meta;
  const { textColor } = getMemberColor(meta.asset_type);
  const _title = meta.title || meta.name;
  const description = meta.description;
  let labelDisabledReason: string[] = [];

  if (disabledLabelOnly) {
    labelDisabledReason = [`This ${meta.asset_type} is selected in the search `];
  }
  if (disabledFull) {
    labelDisabledReason = (unlikelyReasons ?? [])?.map((reason) => {
      if (reason.error_type === "incompatible_asset") {
        return `This ${meta.asset_type} is ${reason.message?.toLowerCase()} `;
      }
      return reason.message;
    });
  }

  const renderContentItem = (label: string, value: string | undefined) => {
    if (!value) return null;
    return (
      <div className="flex ">
        <span style={{ color: textColor }} className="font-normal mr-1">
          {label}:{" "}
        </span>
        <span>{value}</span>
      </div>
    );
  };
  return (
    <Popover
      placement="right"
      title={null}
      content={
        <div onClick={(e) => e.stopPropagation()} className="max-w-[400px] flex flex-col gap-1">
          <span style={{ color: textColor }} className="font-bold">
            {_title}
          </span>
          <Divider className="my-[2px]" />
          {renderContentItem("Name", meta.name)}
          {renderContentItem("Data Type", meta.data_type)}
          {renderContentItem("Asset Type", meta.asset_type)}
          {renderContentItem("Description", description)}
          {labelDisabledReason?.length > 0 && (
            <div className="flex items-start gap-1 text-gray-400">
              <ul className="list-none m-0 p-0">
                {labelDisabledReason?.map((reason) => (
                  <li key={reason}>
                    <ExclamationCircleOutlined className="mt-1 mr-1" />
                    <span>{reason}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      }
      destroyOnHidden
    >
      <div
        onClick={(e) => {
          if (disabledLabelOnly) {
            e.stopPropagation();
          }
        }}
        style={{
          color: disabledLabelOnly ? getMemberColor().textColor : getMemberColor(meta.asset_type).textColor,
        }}
        className={`flex justify-between items-center px-3`}
      >
        <div className="flex flex-col w-[85%]">
          <div className="max-w-full flex overflow-y-hidden relative">
            <div className=" absolute top-[2px]">
              {getDataTypeIcon({
                type: meta.data_type,
                size: 16,
              })}
            </div>
            <Highlighter18
              highlightClassName="bg-yellow-500 text-white"
              className="text-[12px] max-w-full truncate ml-5"
              searchWords={[searchValue]}
              autoEscape={true}
              textToHighlight={_title}
            />
          </div>
          <Highlighter18
            highlightClassName="bg-yellow-500 text-white"
            className="text-[10px] text-gray-500 max-w-full truncate"
            searchWords={[searchValue]}
            autoEscape={true}
            textToHighlight={meta.name}
          />
        </div>
        {!isCustomMetric && (
          <div
            style={{
              color: getMemberColor("filter").textColor,
            }}
            onClick={(e) => {
              if (disabledFilterOnly) return;
              e.stopPropagation();
              control.handleOpenFilterModal?.(meta.name, meta);
            }}
          >
            <FilterIcon disabled={disabledFilterOnly} />
          </div>
        )}
      </div>
    </Popover>
  );
};
